import { render, staticRenderFns } from "./waveform.vue?vue&type=template&id=b38f3380&scoped=true"
import script from "./waveform.vue?vue&type=script&setup=true&lang=js"
export * from "./waveform.vue?vue&type=script&setup=true&lang=js"
import style0 from "./waveform.vue?vue&type=style&index=0&id=b38f3380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38f3380",
  null
  
)

export default component.exports